import z from "zod";

import { MediaPostSchema } from "@features/media-card/model";

import { ColorIconSchema } from "@shared/content-types/schemas/common.schema";
import { StrapiMediaSchema } from "@shared/content-types/schemas/media.schema";

export const ArtSectionSchema = z.object({
  id: z.number().positive(),
  buttonText: z.string().min(1).optional().nullable(),
  buttonLink: z.string().min(1).optional().nullable(),
  title: z.string().min(1),
  variation: z.string().min(1),
  bigIcon: ColorIconSchema.optional().nullable(),
  icon: ColorIconSchema,
  mainImage: StrapiMediaSchema,
  smallImage: StrapiMediaSchema,
  media_post: MediaPostSchema.nullable(),
});

export const ArtSectionsSchema = z.object({
  isVisible: z.boolean().optional().default(true),
  subtitle: z.string().min(1),
  title: z.string().min(1),
  artSections: z.array(ArtSectionSchema),
});
